import AuthAPI from './authInstance'

const getAll = async (params = {}) => {
  const response = await AuthAPI.get(`/admin/payment/list`, { params })
  return response.data
}

const getOne = async (data) => {
  const response = await AuthAPI.get(`/admin/payment/show/${data}`)
  return response.data
}

const checkStatus = async (id) => {
  const response = await AuthAPI.post(`/admin/payment/${id}/check-status`, { mode: 'live' })
  return response.data
}

const getCodes = async (id) => {
  const response = await AuthAPI.get(`/admin/payment/${id}/codes`)
  return response.data
}

export const paymentService = {
  getAll,
  getOne,
  checkStatus,
  getCodes,
}
